import { HttpErrorResponse } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { ToastrService } from "ngx-toastr"
import { Observable, throwError } from "rxjs"
import { HttpStatusCode } from "../models/HttpStatusCode"

@Injectable({
  providedIn: "root",
})
export class HandleErrorService {
  constructor(private toastr: ToastrService) {}

  handleError<T>(result?: T) {
    return (error: HttpErrorResponse): Observable<HttpErrorResponse> => {
      const errors = error.error

      /* Remover esse if na refatoração das tela de edição/criação de usuários */
      if (errors.code === HttpStatusCode.BAD_REQUEST.toString()) {
        this.toastr.error("", `${errors.message}`)
        return
      }

      if (errors.Message) {
        this.toastr.error(``, `${error.error.Message}`)
        return
      }

      if (errors.Errors) {
        errors.Errors.forEach((element) => {
          this.toastr.error(``, `${element.Message}`)
        })
        return
      }
      const errorObject = error
      return throwError(() => errorObject)
    }
  }
}
